import { useCallback, useMemo } from 'react';
import { isEmpty } from 'lodash';

import { Disease } from '@dreryk/medical-dictionaries-api';

import { Autosuggest, useInteractiveTableContext } from '@dreryk/react-components';
import { Bean, ValidationRules } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import { DiagnosisTableBean, VisitDocumentsDiagnosesFormController } from './VisitDocumentsDiagnosesForm.types';
import { diseaseItemRenderer, diseasesSearchCreator } from './VisitDocumentsDiagnosesInteractiveTableSelector.utils';

type VisitDocumentsDiagnosesInteractiveTableSelectorProps = Pick<VisitDocumentsDiagnosesFormController, 'register'>;

export const VisitDocumentsDiagnosesInteractiveTableSelector = (
   props: VisitDocumentsDiagnosesInteractiveTableSelectorProps
): JSX.Element => {
   const { addRow, getValues } = useInteractiveTableContext<DiagnosisTableBean>();

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: isEmpty(getValues()),
      };
   }, [getValues]);

   const handleSelectionChange = useCallback(
      (disease: Disease | null): void => {
         if (disease) {
            addRow({ code: disease.icd10Code, name: disease.name }, 'prepend');
         }
      },
      [addRow]
   );

   return (
      <Autosuggest<Disease>
         minChars={2}
         label={translationKeys.diagnosis}
         keyProperty={'icd10Code'}
         placeholder={translationKeys.fillICD10OrDiagnosisName}
         itemRenderer={diseaseItemRenderer}
         controller={props.register('diagnoses.search', validationRules)}
         searchCreator={diseasesSearchCreator}
         onSelectionChange={handleSelectionChange}
         testId={'disease'}
         horizontal={false}
         defaultValue={null}
         resetAfterSelection
      />
   );
};
